import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .factory('$infiniteScroll', InfiniteScrollConfig);

/* @ngInject */
function InfiniteScrollConfig($log, $q, $timeout, moment) {
  function InfiniteScroll(listRef, limit, config) {

    var self = this;

    self.listRef = listRef;
    self.limit = limit;

    if (!config) {
      config = {
        ignoreFetch: undefined,
        getFullData: undefined,
        options: undefined,
        data: undefined // Request data/body
      }
    }

    self.config = config;
    self._items = [];
    self._itemsCopy = undefined; // For search on existing list (look for search method)
    self._length = 0;
    self._fetching = false;
    self._finished = false;
    self._initialized = false;
    self._itemsChangeHandlers = [];
    self._queryTime = undefined;

    if (!config.ignoreFetch) {
      self._fetchNext(0);
    }
  }

  InfiniteScroll.prototype = {

    _fetchNext: function (index) {

      if (!!this.config.ignoreFetch || this._fetching || this._finished) {
        return;
      }

      var self = this;

      self._fetching = true;
      self._queryTime = moment().valueOf();
      var currentQueryTime = moment().valueOf();

      self.listRef.$next(self.config)
        .then(function (_items) {
          if (!self._queryTime || self._queryTime <= currentQueryTime) {
            self._items = _.union(self._items, _items);
            self._initialized = true;
            self._finished = !_.get(self, 'listRef._cursor') || _items.length < self.limit;
            self._length = self._items.length;
            _.forEach(self._itemsChangeHandlers, function (handler) {
              handler(self._items);
            });
          }
        }, function () {
          $log.debug('Fail to load next');
        })
        .finally(function () {
          self._fetching = false;
        });
    },

    // Required by md-virtual-repeat-container
    getItemAtIndex: function (index) {

      var self = this;

      if (self._items[index]) {
        return self._items[index];
      } else if (!self._fetching && !self._finished) {
        self._fetchNext(index);
      }
    },

    // Required by md-virtual-repeat-container
    getLength: function () {

      var self = this,
        length = (self._fetching || self._finished) ? self._length : (self._length + self.limit);

      //return self._length + (self._fetching ? 0 : self.limit);
      return length;
    },

    size: function () {
      var self = this;
      return self._length;
    },

    isEmpty: function () {
      var self = this;
      return !self._length;
    },

    reload: function (config?) {

      var self = this;

      self._items = [];
      self._itemsCopy = undefined;
      self._length = 0;
      self._fetching = false;
      self._finished = false;
      self._initialized = false;
      self._queryTime = undefined;

      if (!!config) {
        self.config = config;
      }

      self._fetchNext(0);
    },

    search: function (query: string) {
      var self = this;

      if (!query && !!self._itemsCopy) {
        self._items = self._itemsCopy;
        self._itemsCopy = undefined;
      }

      if (!self._itemsCopy) {
        self._itemsCopy = angular.copy(self._items);
      }

      self._items = self._itemsCopy.filter((item) => {
        return _.includes(JSON.stringify(item), query)
      });
      self._length = self._items.length;
    },

    resetItems: function () {

      var self = this;

      self._items = [];
      self._length = 0;
      self._fetching = false;
      self._finished = false;
      self._queryTime = undefined;
    },

    itemsChangeHandler: function (handler) {
      var self = this;
      if (handler) {
        self._itemsChangeHandlers.push(handler);

        return function destroy() {
          self._itemsChangeHandlers.pop();
        }

      }
    },

    addItems: function (items) {
      var self = this;
      self._items = _.union(items, self._items);
      self._length = self._items.length;
      _.forEach(self._itemsChangeHandlers, function (handler) {
        handler(self._items);
      });
    },

    updateItems: function (items) {
      var self = this;

      var updatesById = _.keyBy(items, 'id');

      self._items = _.map(self._items, function (item) {
        return updatesById[item.id]
          ? _.assign({}, item, updatesById[item.id])
          : item;
      });

      self._length = self._items.length;

      _.forEach(self._itemsChangeHandlers, function (handler) {
        handler(self._items);
      });
    },

    removeItems: function (items, idKey?) {
      var self = this;
      self._items = self.config.getFullData ?
        _.differenceBy(self._items, items, idKey || 'id') :
        _.difference(self._items, items);
      self._length = self._items.length;
      _.forEach(self._itemsChangeHandlers, function (handler) {
        handler(self._items);
      });
    },

    removeItemsWithAnimation: function (items) {
      var self = this;
      var elementsRefsList = [];
      _.forEach(items, function (i) {

        var temp = document.getElementsByClassName(i);

        if (temp[0]) {
          temp[0].classList.remove('show');
          elementsRefsList.push(temp[0])
        }
      })

      $timeout(500).then(function () {
        _.forEach(elementsRefsList, function (e) {
          e.classList.add('show')
        })
      });

      $timeout(501).then(function () {
        self._items = _.difference(self._items, items);
        self._length = self._items.length;
        _.forEach(self._itemsChangeHandlers, function (handler) {
          handler(self._items);
        });
      });

    },

    getItems: function (ids) {
      var self = this;
      return !ids ? self._items : _.filter(self._items, function (itemId) {
        _.includes(ids, itemId);
      });
    },

    getItem: function (id) {
      var self = this;
      return _.find(self._items, function (item) {
        if (self.config?.getFullData) {
          return item.id === id;
        } else {
          return item === id;
        }
      });
    },

    isFetching: function () {
      var self = this;
      return self._fetching;
    },

    // True once the first fetch has completed successfully - stays true across reload(),
    // so a caller can use it to show a skeleton only until the very first load, never again.
    isInitialized: function () {
      var self = this;
      return self._initialized;
    },

    isFinished: function () {
      var self = this;
      return self._finished;
    }
  };

  return function infiniteScrollConstructor(listRef, limit, doNotFetchOnInit) {
    return new InfiniteScroll(listRef, limit, doNotFetchOnInit);
  }
}
